import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Link, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

const CONSENT_KEY = "cookies_consent_v1";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 16,
    display: "flex",
    justifyContent: "center",
    zIndex: 1400,
    pointerEvents: "none",
  },
  card: {
    pointerEvents: "auto",
    maxWidth: 920,
    width: "calc(100% - 24px)",
    background: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    padding: 16,
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  textBox: {
    flex: 1,
    color: "#1a1a1a",
  },
  actions: {
    display: "flex",
    gap: 8,
  },
  primary: {
    backgroundColor: "#1d649c",
    color: "#fff",
    textTransform: "none",
    borderRadius: 10,
    padding: "8px 16px",
    "&:hover": { backgroundColor: "#195f93" },
  },
  secondary: {
    backgroundColor: "#b3daff",
    color: "#000",
    textTransform: "none",
    borderRadius: 10,
    padding: "8px 16px",
    "&:hover": { backgroundColor: "#1d649c", color: "#fff" },
  },
  link: {
    color: "#1d649c",
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

export default function CookiesConsent() {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(CONSENT_KEY);
      if (!stored) setOpen(true);
    } catch (_) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    try { window.localStorage.setItem(CONSENT_KEY, "accepted"); } catch (_) {}
    setOpen(false);
  };

  const handleDecline = () => {
    try { window.localStorage.setItem(CONSENT_KEY, "declined"); } catch (_) {}
    setOpen(false);
  };

  const goToPolicy = (e) => {
    e.preventDefault();
    setOpen(false);
    history.push("/cookies-policy");
  };

  if (!open) return null;

  return (
    <Box className={classes.wrapper}>
      <Paper elevation={0} className={classes.card}>
        <Box className={classes.textBox}>
          <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 4 }}>
            We use cookies to improve your experience
          </Typography>
          <Typography variant="body2">
            By clicking Accept, you agree to the storing of cookies on your device to
            enhance site navigation, analyze site usage, and assist in our marketing
            efforts. Read more in our {" "}
            <Link onClick={goToPolicy} className={classes.link}>Cookies Policy</Link>.
          </Typography>
        </Box>
        <Box className={classes.actions}>
          <Button onClick={handleDecline} className={classes.secondary} variant="contained">Decline</Button>
          <Button onClick={handleAccept} className={classes.primary} variant="contained">Accept</Button>
        </Box>
      </Paper>
    </Box>
  );
}


